/* SCRIN — interacciones */
(function () {
  'use strict';
  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  /* fetch limpio desde un iframe: evita que apps que parchean fetch/XHR reescriban el agregado */
  function cleanFetch() {
    if (window.__scFetch) return window.__scFetch;
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      f.setAttribute('aria-hidden', 'true');
      document.documentElement.appendChild(f);
      window.__scFetch = f.contentWindow.fetch.bind(window);
    } catch (e) {
      window.__scFetch = window.fetch.bind(window);
    }
    return window.__scFetch;
  }
  async function quickAdd(btn) {
    var card = btn.closest('.sc-var__card');
    var sel = card ? card.querySelector('[data-sc-sel]') : null;
    var id = (sel && sel.value) || btn.dataset.scAdd;
    if (!id || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    const cart = getCart();
    const _fetch = cleanFetch();
    const body = new FormData();
    body.append('id', id);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append('sections', cart.getSectionsToRender().map((s) => s.id).join(','));
      body.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    try {
      const res = await _fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message || 'Error');
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: id, cartData: data });
      }
      /* Si está el carrito de la app (Section Store): sincronizarlo y abrirlo */
      var appCart = document.querySelector('section-store--cart-block');
      if (appCart) {
        try {
          await window.fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: {} }),
          });
        } catch (e) {}
        var icon = document.querySelector('#cart-icon-bubble');
        if (icon) icon.click();
      } else if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      btn.classList.add('is-done');
      setTimeout(() => btn.classList.remove('is-done'), 1600);
    } catch (e) {
      console.error('[scrin] quick add', e);
      alert(e.message || 'No se pudo agregar al carrito');
    } finally {
      btn.classList.remove('is-loading');
    }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sc-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    quickAdd(btn);
  });
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-sc-sel]');
    if (!sel) return;
    const card = sel.closest('.sc-var__card');
    const link = card && card.querySelector('[data-sc-link]');
    if (link) link.href = link.href.replace(/variant=\d+/, 'variant=' + sel.value);
  });
  function initCarousel(root) {
    const track = root.querySelector('.sc-track');
    if (!track) return;
    const items = Array.from(track.children);
    const dots = root.querySelector('.sc-dots');
    if (dots && items.length > 1) {
      dots.innerHTML = '';
      items.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
        if (i === 0) b.classList.add('on');
        b.addEventListener('click', () => items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
        dots.appendChild(b);
      });
    }
    const update = () => {
      if (!dots) return;
      const left = track.scrollLeft + track.clientWidth / 2;
      let idx = 0;
      items.forEach((el, i) => { if (el.offsetLeft < left) idx = i; });
      dots.querySelectorAll('button').forEach((d, i) => d.classList.toggle('on', i === idx));
    };
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    root.querySelectorAll('[data-sc-next]').forEach((b) => b.addEventListener('click', () => {
      const w = items[0] ? items[0].getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: w, behavior: 'smooth' });
    }));
    root.querySelectorAll('[data-sc-prev]').forEach((b) => b.addEventListener('click', () => {
      const w = items[0] ? items[0].getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: -w, behavior: 'smooth' });
    }));
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sc-carousel]').forEach((r) => {
      if (r.dataset.scReady) return;
      r.dataset.scReady = '1';
      initCarousel(r);
    });
    (scope || document).querySelectorAll('[data-sc-flag]').forEach((el) => {
      const iso = (el.dataset.scFlag || '').toUpperCase();
      if (iso.length !== 2) return;
      el.textContent = String.fromCodePoint(...[...iso].map((c) => 127397 + c.charCodeAt(0)));
    });
    (scope || document).querySelectorAll('[data-sc-mute]').forEach((btn) => {
      if (btn.dataset.scReady) return;
      btn.dataset.scReady = '1';
      btn.addEventListener('click', () => {
        const tile = btn.closest('.sc-videos__tile');
        const video = tile && tile.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        tile.classList.toggle('is-sound', !video.muted);
        if (!video.muted) video.play().catch(() => {});
      });
    });
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-sc-scroll]');
    if (!a) return;
    const target = document.querySelector(a.dataset.scScroll || '.product-form__submit');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
